export default theme =>({
    textField: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(1),
            padding:theme.spacing(1),
            width: '90%',
        },

})